module.exports = __webpack_public_path__ + "img/kanggox.0d1f612a.png";